import * as React from "react";
import { required, SelectInput } from "react-admin";

const CreateClient = () => (
  <SelectInput
    sx={{ width: "14%" }}
    source="entity"
    choices={[{ name: "resources.Client.source.entity.physical", id: 1 }]}
    validate={[required()]}
  />
);

export default CreateClient;
